import Container from "../../layouts/containers/container";
import List from "../list";
import RenderThisIf from "../renderIf";
import ClipLoader from "react-spinners/ClipLoader";

export default function EmptyState({
    title,
    description,
    style = {},
    loading = false,
    titleColor = 'white',
    descriptionColor = 'white',
    showImage = true,
}) {
    return <Container style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...style,
    }}>
        <Container.Content>
            <RenderThisIf
                renderIf={loading}
                render={
                    <img src="/assets/SVG/spin.png" className="spin" style={{ width: '80px', height: '80px' }}/>
                }
            >
                <List gap="5px" style={{
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    { showImage && <img src="/assets/empty.png" style={{ height: '300px', marginBottom: '10px' }}/> }
                    <Container.Text fontSize="20px" color={titleColor}>{ title }</Container.Text>
                    <Container.Text fontSize="16px" color={descriptionColor}>{ description }</Container.Text>
                </List>
            </RenderThisIf>
        </Container.Content>
    </Container>
}